// extracted by mini-css-extract-plugin
export default {"progressContainer":"Progress_progressContainer__Q-ktF","progressText":"Progress_progressText__QxUQl"};